import { supabase } from '../lib/supabase';

export type NewWebTicketPayload = {
  id: string;
  asunto: string;
  empresa: string;
  origen_requerimiento: 'Web';
  proveniente_web: true;
  nombre_solicitante: string;
  email: string;
  telefono: string;
  descripcion_problema: string;
};

export async function createWebTicket(payload: NewWebTicketPayload) {
  if (!supabase) {
    throw new Error('Supabase no est\u00e1 configurado. Revisa las variables VITE_SUPABASE_URL y VITE_SUPABASE_ANON_KEY.');
  }

  const { error, status } = await supabase.from('tickets_web').insert(payload);

  if (error) {
    if (status === 404) {
      throw new Error("La tabla 'tickets_web' no existe o no está disponible en la API. Ejecuta el script SQL de creación.");
    }

    const details = [error.message, error.details, error.hint].filter(Boolean).join(' | ');
    throw new Error(details || 'Error al crear el ticket en Supabase.');
  }

  return { ok: true, ticketId: payload.id };
}
